export type AppSurface = "workspace" | "admin" | "mission";

export function resolveAppSurface(
  hostname = typeof window === "undefined" ? "" : window.location.hostname,
  search = typeof window === "undefined" ? "" : window.location.search,
): AppSurface {
  const host = hostname.toLowerCase().split(":")[0];
  if (host === "admin.raqoz.com") return "admin";
  if (host === "mission.raqoz.com") return "mission";

  const preview = new URLSearchParams(search).get("surface");
  if (
    (host === "localhost" || host === "127.0.0.1" || host.endsWith(".lovable.app")) &&
    (preview === "admin" || preview === "mission")
  ) {
    return preview;
  }
  return "workspace";
}

export function surfaceName(surface: AppSurface) {
  if (surface === "admin") return "RAQOZ Admin";
  if (surface === "mission") return "RAQOZ Mission Control";
  return "RAQOZ";
}

export function surfaceDescription(surface: AppSurface) {
  if (surface === "admin")
    return "Manage your organisation, people, access, controls and service readiness.";
  if (surface === "mission")
    return "Cyclotron-only operational oversight without tenant impersonation.";
  return "Requirement-to-outcome procurement orchestration.";
}

export function surfaceHome(surface: AppSurface) {
  if (typeof window === "undefined") return "/app";
  const local =
    window.location.hostname === "localhost" ||
    window.location.hostname === "127.0.0.1" ||
    window.location.hostname.endsWith(".lovable.app");
  if (local && surface !== "workspace")
    return `/app?surface=${surface}`;
  if (surface === "admin") return "https://admin.raqoz.com/app";
  if (surface === "mission") return "https://mission.raqoz.com/app";
  return "https://raqoz.com/app";
}
